import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { getSessionItem, removeSessionItem } from '../../shared/utils';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  userAccount: { name?: string } = {};

  constructor(private route: ActivatedRoute, private router: Router,) {}

  ngOnInit() {

    // check if user is logged in and redirect
    const currentUser = getSessionItem('userAccount');
    if (currentUser) {
      this.userAccount = currentUser;
    }

  }

  handleSignOut() {
    removeSessionItem('accessToken');
    removeSessionItem('userAccount');

    this.router.navigate(['/signin']);
    return false;
  }

}
